export const validEmailRegex = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
export const validContactNumRegex = /^\D*(\d{0,3})\D*(\d{0,3})\D*(\d{0,4})/;
export const allowOnlyNumber= /^[\d\$]+$/;
export const validPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
export const allowOnlyText= /^[A-Za-z ]+$/;
